import React from 'react';
import PropTypes from 'prop-types';

import LoginFormContainer from './LoginFormContainer';

const propTypes = {
  authError: PropTypes.string,
};

const defaultProps = {
  authError: '',
};

const LoginPage = ({ authError }) => (
  <div className="row">
    <div className="col-md-6 col-md-offset-3">
      <div className="card card-block">
        <h2 className="card-title">Log In</h2>
        {authError ? <p className="alert alert-danger">{authError}</p> : null}
        <p className="card-text">
          Please log in below to access Datarista content. All fields are required.
        </p>
        <LoginFormContainer />
      </div>
    </div>
  </div>
);

LoginPage.propTypes = propTypes;
LoginPage.defaultProps = defaultProps;

export default LoginPage;
